import { Theme, alpha } from '@material-ui/core';

const ACCESS_CHIP_COLOR: Record<string, (theme: Theme) => string> = {
  READ: theme => theme.palette.primary.main,
  WRITE: theme => theme.palette.warning.dark,
  ACCESS: theme => theme.palette.info.main,
  INSTALL: theme => theme.palette.success.main,
  EXECUTE: theme => theme.palette.primary.dark,
  ADMIN: theme => theme.palette.error.main,
  MANAGE: theme => theme.palette.primary.dark,
  CREATE: theme => theme.palette.success.main,
  EXPORT: theme => theme.palette.info.main,
  ESCALATE: theme => theme.palette.error.dark,
  COORDINATE: theme => theme.palette.info.dark,
  ATTRIBUTES: theme => theme.palette.primary.dark,
  MODIFIERS: theme => theme.palette.primary.dark,
  'PLATFORM-ROLES': theme => theme.palette.primary.dark,
};

export function getAccessChipClassName(access: string): string {
  if (ACCESS_CHIP_COLOR[access]) return `access-${access.toLowerCase()}`;
  return 'access-other';
}

export function buildAccessChipVariants(theme: Theme) {
  const variants: Record<string, Record<string, string>> = {
    '&.access-other': {
      background: 'transparent !important',
      border: `1px solid ${theme.palette.divider}`,
      color: theme.palette.text.secondary,
    },
  };

  Object.keys(ACCESS_CHIP_COLOR).forEach(access => {
    const color = ACCESS_CHIP_COLOR[access](theme);

    variants[`&.access-${access.toLowerCase()}`] = {
      background: `${alpha(color, 0.14)} !important`,
      color: `${color} !important`,
    };
  });

  return variants;
}
